import { useEffect, useLayoutEffect } from "react"

/** only fire when a property changes
 * @example
 *  whenPropertyChanges(privacy, () => {
 *     console.log(privacy)
 *  })
 */
export const whenPropertyChanges = (property, onPropertyChanged, onCleanup) => {
    useEffect(() => {
        if (onPropertyChanged) {
            onPropertyChanged()
        }
        if (onCleanup) {
            return onCleanup
        }
        return () => {}
    }, [property])
}
/** fire on every render
 * @example
 *  afterRender(() => {
 *     console.log(privacy)
 *  })
 */
export const afterRender = (afterRender, onCleanup) => {
    useEffect(() => {
        if (afterRender) {
            afterRender()
        }
        if (onCleanup) {
            return onCleanup
        }
        return () => {}
    })
}
/** only use this if you're maniuplating
 *  the DOM and you notice flicker
 * @example
 *  slowBeforeRender(() => {
 *     console.log(privacy)
 *  })
 *
 */
export const slowBeforeRender = (beforeRender, onCleanup) => {
    useLayoutEffect(() => {
        if (beforeRender) {
            beforeRender()
        }
        if (onCleanup) {
            return onCleanup
        }
        return () => {}
    })
}



// WEBPACK FOOTER //
// ./src/wrappers.js